<template lang="pug">
    .container.mx-auto.spacingTopStandard.spacingBottomStandard
      table.table.table-auto
        tbody
          tr
            td(width='307') Asian Palate Jeannie Cho Lee
            td(width='307')
              a(href='http://www.asianpalate.com/') http://www.asianpalate.com
          tr
            td(width='307') Bettane et Desseauve
            td(width='307')
              a(href='http://www.bettanedesseauve.com/') http://www.bettanedesseauve.com
          tr
            td(width='307') Beverage Testing Institute
            td(width='307')
              a(href='http://www.tastings.com/') http://www.tastings.com
          tr
            td(width='307') Bob Campbell
            td(width='307')
              a(href='http://www.bobswinereviews.com/') http://www.bobswinereviews.com
          tr
            td(width='307') CellarTracker
            td(width='307')
              a(href='http://www.cellartracker.com/') http://www.cellartracker.com
          tr
            td(width='307') Decanter
            td(width='307')
              a(href='http://www.decanter.com/') http://www.decanter.com
          tr
            td(width='307') Falstaff
            td(width='307')
              a(href='http://www.falstaff.de/') http://www.falstaff.de
          tr
            td(width='307') Gambero Rosso
            td(width='307')
              a(href='http://www.gamberorosso.it/') http://www.gamberorosso.it
          tr
            td(width='307') Gault et Millau
            td(width='307')
              a(href='http://www.gaultmillau.fr/') http://www.gaultmillau.fr
          tr
            td(width='307') Guia Penin
            td(width='307')
              a(href='http://www.guiapenin.com/') http://www.guiapenin.com
          tr
            td(width='307') Guia Repsol
            td(width='307')
              a(href='http://www.guiarepsol.com/') http://www.guiarepsol.com
          tr
            td(width='307') Huon Hooke
            td(width='307')
              a(href='http://www.huonhooke.com/') http://www.huonhooke.com
          tr
            td(width='307') James Halliday
            td(width='307')
              a(href='http://www.winecompanion.com.au/') http://www.winecompanion.com.au
          tr
            td(width='307') James Suckling
            td(width='307')
              a(href='http://www.jamessuckling.com/') http://www.jamessuckling.com
          tr
            td(width='307') Jancis Robinson
            td(width='307')
              a(href='http://www.jancisrobinson.com/') http://www.jancisrobinson.com
          tr
            td(width='307') Jean Marc Quarin
            td(width='307')
              a(href='http://www.quarin.com/') http://www.quarin.com
          tr
            td(width='307') Jeff Leve
            td(width='307')
              a(href='http://www.thewinecellarinsider.com/') http://www.thewinecellarinsider.com
          tr
            td(width='307') Jeremy Oliver
            td(width='307')
              a(href='http://www.jeremyoliver.com.au/') http://www.jeremyoliver.com.au
          tr
            td(width='307') La Revue du Vin de France
            td(width='307')
              a(href='http://www.larvf.com/') http://www.larvf.com
          tr
            td(width='307') Platter’s South African Wine Guide
            td(width='307')
              a(href='http://www.wineonaplatter.com/') http://www.wineonaplatter.com
          tr
            td(width='307') Robert Parker The Wine Advocate
            td(width='307')
              a(href='http://www.erobertparker.com/') http://www.erobertparker.com
          tr
            td(width='307') Vinum Wine Magazine
            td(width='307')
              a(href='http://www.vinum.de/') http://www.vinum.de
          tr
            td(width='307') Wine & Spirits Magazine
            td(width='307')
              a(href='http://www.wineandspiritsmagazine.com/') http://www.wineandspiritsmagazine.com
          tr
            td(width='307') Wine Enthusiast
            td(width='307')
              a(href='http://www.wineenthusiast.com/') http://www.wineenthusiast.com
          tr
            td(width='307') Wine Pros Archive
            td(width='307')
              a(href='http://www.winepros.com.au/') http://www.winepros.com.au
          tr
            td(width='307') Wine Spectator
            td(width='307')
              a(href='http://www.winespectator.com/') http://www.winespectator.com

</template>

<script>
export default {
    name: 'Table4'
    // Weinexperten/Fachmedien
};
</script>

<style lang="sass" scoped>
.table
  @apply table w-full

  tr:nth-child(odd)
    @apply bg-gray-100

  &:first-child
    td
    @apply border-t
  td, th
    @apply border-b border-r
    padding: 6px 10px
    &:first-child
      @apply border-l
</style>
